import styled, { css } from 'styled-components';
import { LayoutAppearance } from './AdFormLayout.types';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { Button } from '@/components/UI/Button/Button';
import { PageTopControls } from '@/components/PageTopControls/PageTopControls';

export const Wrapper = styled.div`
  width: 100%;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;

  @media (max-width: 949px) {
    padding: 5px 0;
  }
`;

export const Card = styled.div<{ $appearance: LayoutAppearance }>`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 850px;
  height: 800px;
  padding: 40px 50px 50px 50px;
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 22px;

  @media (max-width: 949px) {
    width: 100%;
    height: auto;
    padding: 0;
    background: transparent;
    border-radius: 0;
  }

  ${({ $appearance }) =>
    $appearance === 'form' &&
    css`
      width: 720px;
      gap: 40px;
      padding: 60px;
      height: auto;
    `}
`;

export const CardHead = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  min-height: 25px;
`;

export const CardTitle = styled(Typography.Header)<{
  $appearance: LayoutAppearance;
}>`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 400px;
  text-align: center;
  font-size: ${({ $appearance }) => ($appearance === 'form' ? 24 : 22)}px;
  font-weight: 700;
`;

export const CardCloseButton = styled(Button).attrs({
  appearance: 'transparent',
  hasPadding: false,
})`
  margin: 3px 0;
  cursor: pointer;
`;

export const ResetButton = styled(Button).attrs<{ disabled: boolean }>({
  hasPadding: false,
  appearance: 'transparent',
})`
  font-size: 15px;
  color: ${({ theme }) => theme.palette.brand.main};

  @media (min-width: 950px) {
    margin-top: 7px;
    font-size: 18px;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${({ theme }) => theme.palette.tertiary.labels};
    `}
`;

export const AdFormPageTopControls = styled(PageTopControls)`
  @media (min-width: 744px) and (max-width: 949px) {
    padding: 0 25px;
  }
`;
